import React from 'react';
import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { styled, Card, useMediaQuery, useTheme } from '@/theme/index';

const CardStyled = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

const StyledImg = styled('img')(() => ({
  width: '100%',
  cursor: 'pointer',
}));

interface PerksBannerSectionProps {
  permalink?: string;
}

/**
 * The PerksBanner component displays the member perk section of the property report.
 */
export const PerksBannerSection = ({ permalink }: PerksBannerSectionProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { navigate } = useAppConfigContext().routingUtils;
  const {
    images: { imgPerksBanner, imgPerksBannerMob },
  } = useAppConstantsContext();

  const handleClick = () => {
    const url = `/dashboard/rewards?permalink=${permalink}`;
    navigate(url);
  };

  return (
    <CardStyled
      variant="outlined"
      id="rewards-section"
      data-testid="rewards-section"
    >
      <StyledImg
        data-testid="perks-banner"
        onClick={handleClick}
        src={isMobile ? imgPerksBannerMob : imgPerksBanner}
      />
    </CardStyled>
  );
};
